import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import Iconify from '../iconify/Iconify';
import { useNavigate } from 'react-router-dom';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ChangePassModal = ({
    visible = false,
    dataUpdate,
    setVisible,
    fuctGet,
    idPermission,
    isEdit,
    isConfigEmailSMTP,
    emailSMTP,
}) => {
    const { t } = useTranslation();
    const [value, setValue] = useState({
        passOld: '',
        passNew: '',
        passConfirm: '',
    });
    const navigate = useNavigate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addCabinetFlag = React.useRef(false);

    const handleOnChange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
    };

    const [showPassword, setShowPassword] = useState(false);

    const handleEdit = () => {
        if (addCabinetFlag.current === true) return;

        if (isConfigEmailSMTP) {
            if (!value.passConfirm.trim() || !value.passNew.trim()) return toast.error(t('error.param'));
            if (value.passConfirm.trim() !== value.passNew.trim()) return toast.error(t('error.confirm_pass'));

            addCabinetFlag.current = true;
            setFlagAddStat(true);
            let InVal = [emailSMTP, value.passConfirm];
            sendRequest(serviceList.changePassEmailSMTP, InVal, actionResult, true, timeOutFunct, 40000);
        } else {
            if (!value.passConfirm.trim() || !value.passNew.trim() || !value.passOld.trim())
                return toast.error(t('error.param'));
            if (value.passConfirm.trim() !== value.passNew.trim()) return toast.error(t('error.confirm_pass'));

            addCabinetFlag.current = true;
            setFlagAddStat(true);
            let InVal = [btoa(value.passOld), btoa(value.passConfirm), glb_sv.userInfo.id];
            sendRequest(serviceList.changePass, InVal, actionResult, true, timeOutFunct, 40000);
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);

            if (isConfigEmailSMTP) {
                setTimeout(() => {
                    setVisible(false);
                    fuctGet && fuctGet();
                }, 500);
            } else {
                setTimeout(() => {
                    sessionStorage.removeItem('proc_data');
                    sessionStorage.removeItem('menu');
                    glb_sv.authFlag = false;
                    navigate('/login');
                }, 500);
            }
        }
    };
    const timeOutFunct = (reqInfo) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {t('change_password')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Loader loading={flagAddStat} />
                <Grid container spacing={2}>
                    {!isConfigEmailSMTP && (
                        <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                            <TextField
                                name="passOld"
                                required
                                fullWidth
                                size="small"
                                label={t('pass_now')}
                                onChange={handleOnChange}
                                type={showPassword ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    )}
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TextField
                            name="passNew"
                            required
                            label={t('pass_new')}
                            fullWidth
                            size="small"
                            onChange={handleOnChange}
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />{' '}
                    </Grid>
                    <Grid style={{ width: '100%' }} item xl={12} md={12} sm={12}>
                        <TextField
                            name="passConfirm"
                            required
                            fullWidth
                            size="small"
                            label={t('pass_confirm')}
                            onChange={handleOnChange}
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />

                <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ChangePassModal;
